export const getImgPath = (filePath: string) => `/releases/default/assets/images/react${filePath}`
